import { PipeTransform, Pipe } from '@angular/core';
@Pipe({
    name: 'filterPermanetExempt'
})
export class FilterPermanetExemptPipe implements PipeTransform {
    transform(value, etpaStatus) {
        if (value) {
            if ((etpaStatus && etpaStatus.indexOf('MR') >= 0)) {
                return value;
            } else {
                return value.filter(item => item.code !== 'MarketRateThreshold');
            }
        }
    }
}
